import { ApiUtil as api } from "@/utils/api.util.js";

export class StatusService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/statuses/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/status.service.js